import { connect } from 'react-redux';
import _ from 'lodash';

const OnlyClassroom = (props) => (props.experience === 'classroom' && props.children) || null; 
export default connect(state => ({ experience: _.get(state.app, 'APP_EXPERIENCE') }))(OnlyClassroom);
